import { useSelector } from "react-redux";
import {
  FormControl,
  NativeSelect
} from "@mui/material";
import { SiteSettingModalContainer, TagsTitle } from "../MapStyled";
import { CircleBtn } from "assets/css/globle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import Draggable from "react-draggable";

const COGAndTeeAndPOIEditPopup = ({
  modalPos,
  courseEditName,
  handleEditCourseChange,
  editHoleNo,
  setEditHoleNo,
  handleEditChange,
  holeCount,
  teeEditValue,
  teeEditHandleChange,
  cogDistan,
  modalState,
  poiEditTypeValue,
  poiEditHandleChange,
  poiEditPositionValue,
  poiEditPositionHandleChange,
  saveEditMarkers,
  editCogTeePoiSaveActiveButton,
  cancelDialogOpen,
  teeMarkersDataState,
  setTeeMarkersDataState,
  editId,
  deleteId,
  siteId,
  setEditModel,
  pointsOfInterestDataState,
  setPointsOfInterestDataState
}) => {
  const { siteSettingsData, siteSetupData } = useSelector((state) => state.commonReducers) || [];

  const { t } = useTranslation();
  const dispatch = useDispatch();

  function deleteMarkers() {
    if (modalState === "tee" && teeMarkersDataState) {
      let newDataTemp = JSON.parse(JSON.stringify(teeMarkersDataState));

      let filterData =
        newDataTemp &&
        newDataTemp.length !== 0 &&
        newDataTemp.filter((el) => {
          return el?.Id !== Number(editId);
        });
      dispatch(COMMON_SERVICES.deleteTeeMarkerServices(deleteId, siteId)).then(() => {
        setTeeMarkersDataState(filterData);
      });
      setEditModel(false);
    } else if (modalState === "poi" && pointsOfInterestDataState) {
      let newDataTemp = JSON.parse(JSON.stringify(pointsOfInterestDataState));

      let filterData =
        newDataTemp &&
        newDataTemp.lenght !== 0 &&
        newDataTemp.filter((el) => {
          return el?.Id !== Number(editId);
        });

      setPointsOfInterestDataState(filterData);
      dispatch(COMMON_SERVICES.deletePoiMarkerServices(deleteId, siteId));
      setEditModel(false);
    }
    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId));
  }

  const draggableModalStyle = {
    position: "fixed",
    top: modalPos.y,
    left: modalPos.x,
    zIndex: 9999,
    background: "white",
    border: "1px solid #ccc",
    borderRadius: 8,
    width: 300,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    padding: 20
  }

  const modalHeaderStyle = {
    padding: "0px 0px 10px 0px",
    cursor: "move",
    fontWeight: "bold",
    borderBottom: "1px solid #eee"
  }

  const selectLabelStyle = {
    color: "#7c7b7b",
    padding: "0px 0px 5px 0px",
  }

  const buttonsStyle = {
    display: "flex",
    padding: 10,
    gap: 5,
    justifyContent: "center"
  }

  return (
    <Draggable handle=".modal-header">
      <div style={draggableModalStyle}>
        <SiteSettingModalContainer>

          <div className="modal-header" style={modalHeaderStyle}>
            {t("Edit_Site_Settings")}
          </div>

          <div style={selectLabelStyle}>
            {t("Select_Course")}
          </div>
          <FormControl fullWidth>
            <NativeSelect
              value={courseEditName}
              onChange={(e) => handleEditCourseChange(e)}
            >
              {siteSettingsData &&
                siteSettingsData?.Courses?.map((item) => (
                  <option key={item?.Number} value={item?.Number}>
                    {item?.Name}
                  </option>
                ))}
            </NativeSelect>
          </FormControl>

          <div style={selectLabelStyle}>
            {t("Select_Hole")}
          </div>
          <FormControl fullWidth>
            <NativeSelect
              value={editHoleNo}
              onChange={(e) => handleEditChange(e, setEditHoleNo)}
            >
              {holeCount !== null &&
                [...Array(holeCount)].map((elementInArray, index) => (
                  <option key={index + 1} value={index + 1}>{index + 1}</option>
                ))}
            </NativeSelect>
          </FormControl>


          {modalState === "tee" ? (
            <>
              <div style={selectLabelStyle}>
                {t("Select_Tee")}
              </div>
              <FormControl fullWidth>
                <NativeSelect
                  value={teeEditValue}
                  onChange={(e) => teeEditHandleChange(e)}
                >
                  {siteSetupData.TeeMarkerSettings.map((item, i) => (
                    <option key={i} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>

              {cogDistan && <TagsTitle>Distance (CoG): {cogDistan} yd</TagsTitle>}
            </>
          ) : (
            <></>
          )}
          {modalState === "poi" ? (
            <>
              <div style={selectLabelStyle}>
                {t("Select_Type")}
              </div>

              <FormControl fullWidth>
                <NativeSelect
                  value={poiEditTypeValue}
                  onChange={(e) => poiEditHandleChange(e)}
                >
                  <option value={2}>{t("Hole")}</option>
                  <option value={3}>{t("Approach")}</option>
                </NativeSelect>
              </FormControl></>
          ) : (
            <></>
          )}
          {modalState === "poi" ? (
            <>
              <div style={selectLabelStyle}>
                {t("Select_Position")}
              </div>
              <FormControl fullWidth>
                <NativeSelect
                  value={poiEditPositionValue}
                  onChange={(e) => poiEditPositionHandleChange(e)}
                >
                  <option value={0}>{t("Left")}</option>
                  <option value={1}>{t("Right")}</option>
                  <option value={2}>{t("Above")}</option>
                  <option value={3}>{t("Below")}</option>
                </NativeSelect>
              </FormControl>
            </>
          ) : (
            <></>
          )}

          <div style={buttonsStyle}>
            <CircleBtn
              onClick={saveEditMarkers}
              className={editCogTeePoiSaveActiveButton ? "active" : "disabled"}
              disabled={!editCogTeePoiSaveActiveButton}
            >
              {t("Save")}
            </CircleBtn>
            <CircleBtn onClick={() => cancelDialogOpen("handleEditClose")}>
              {t("Cancel")}
            </CircleBtn>
            {modalState === "cog" ? null : (
              <CircleBtn
                onClick={() => {
                  deleteMarkers();
                }}
              >
                {t("Delete")}
              </CircleBtn>
            )}
          </div>

        </SiteSettingModalContainer>
      </div>
    </Draggable>
  );
};

export default COGAndTeeAndPOIEditPopup;
